import { render, staticRenderFns } from "./Dialog_UpdateTeacher.vue?vue&type=template&id=084c2a6e&scoped=true&"
import script from "./Dialog_UpdateTeacher.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c2a6e",
  null
  
)

export default component.exports